module.exports = __webpack_public_path__ + "static/assets/9ecfc22bb2fae434d72acfa182df6927.png";